export const initialState = { fetching: false, fetched: false, error: null }

const pending   = (state) => ({...state, fetching: true, fetched: false, error: null})
const rejected  = (state, payload) => ({...state, fetching: false, fetched: false, error: payload})
const fulfilled = (state, payload) => ({...state, fetching: false, fetched: true, ...payload })

export default (state=initialState, {type, payload}, constants, constantType) => {
  switch(type) {
    case constants[`FETCH_${constantType}_PENDING`]:
      return pending(state)
    case constants[`FETCH_${constantType}_FULFILLED`]:
      return fulfilled(state, payload)
    case constants[`FETCH_${constantType}_REJECTED`]:
      return rejected(state, payload)
    default:
      return state
  }
}
